"use client";

import { motion, useMotionValueEvent, useScroll, useTransform } from "motion/react";
import { useState } from "react";

export function ScrollProgress() {
  const { scrollY, scrollYProgress } = useScroll();
  const [visible, setVisible] = useState(false);
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);

  useMotionValueEvent(scrollY, "change", (v) => {
    setVisible(v > 100);
  });

  return (
    <motion.div
      aria-hidden
      style={{
        scaleX,
        transformOrigin: "0% 50%",
        opacity: visible ? 1 : 0,
      }}
      className="fixed inset-x-0 top-[71px] z-50 h-px origin-left bg-brand transition-opacity"
    />
  );
}
